(function($) {

	'use strict';

	var init = function() {

        $('.owl-carousel').owlCarousel({
            loop: true,
            center: true,
            drag: false,
            items: 1,
            dots: true,
            autoplay: true,
        });
        $('.count').counterUp({
            delay: 10,
            time: 1000
        });

	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
